import { render, staticRenderFns } from "./EventCardVariant1.vue?vue&type=template&id=452bc67c&scoped=true&"
import script from "./EventCardVariant1.vue?vue&type=script&lang=js&"
export * from "./EventCardVariant1.vue?vue&type=script&lang=js&"
import style0 from "./EventCardVariant1.vue?vue&type=style&index=0&id=452bc67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bc67c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
